/*@flow*/
import React from 'react';
import { withRouter } from 'react-router';
import { type ContextRouter } from 'react-router-dom';

type Props = ContextRouter & { andThen?: Props => any };

class Component extends React.Component<Props> {
  componentDidMount() {
    window.scrollTo(0, 0);

    if (document.body) {
      document.body.scrollTop = 0;
    }

    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }

    setTimeout(() => {
      this.props.andThen && this.props.andThen(this.props);
    }, 500);
  }

  shouldComponentUpdate(np: Props) {
    return np.location.pathname !== this.props.location.pathname;
  }

  render() {
    return null;
  }
}

export default withRouter<*>(Component);
